// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"356":"eeac31ba","787":"8c6619b3"}[chunkId] + ".chunk.js";
};